'use client'

export function StatsSection() {
  return (
    <section
      className="bg-black py-16 md:py-32"
      style={{ fontFamily: 'var(--font-ppmori, PPMori), sans-serif' }}
    >
      <div className="mx-auto max-w-5xl space-y-8 px-6 md:space-y-12">
        <div className="relative z-10 max-w-xl space-y-6">
          <h2 className="text-4xl font-medium text-white lg:text-5xl">
            Numbers that speak for themselves.
          </h2>
          <p className="text-white/60">
            Algoglide is built for traders who want an edge — not noise. Every signal is scanned, filtered, and delivered with context so you can act with conviction.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 md:gap-12 lg:gap-24">
          {/* Stats */}
          <div>
            <p className="text-white/60">
              From breakout alerts to full technical analysis, the platform works around the clock so you never miss a move — whether you&apos;re watching the screen or not.
            </p>
            <div className="mb-12 mt-12 grid grid-cols-2 gap-2 md:mb-0">
              <div className="space-y-3">
                <div className="text-5xl font-medium text-white">$1M+</div>
                <p className="text-sm text-white/50">made by traders in a single month</p>
              </div>
              <div className="space-y-3">
                <div className="text-5xl font-medium text-white">100+</div>
                <p className="text-sm text-white/50">signals generated every day</p>
              </div>
            </div>
          </div>

          {/* Quote */}
          <div className="relative">
            <blockquote className="border-l-2 border-[#ffb703] pl-5">
              <p className="text-white/70 leading-relaxed">
                I&apos;ve been trading for four years and nothing has come close to this. The signals are consistent, the reasoning makes sense, and I&apos;ve had my best month ever since I started using Algoglide. The scanner alone is worth it.
              </p>
              <div className="mt-6 flex items-center gap-3">
                <img
                  src="/images/parfait.png"
                  alt="Parfait"
                  className="h-8 w-8 object-cover"
                />
                <cite className="not-italic">
                  <span className="block text-sm font-medium text-white">Parfait</span>
                  <span className="block text-xs text-white/40">Zurich</span>
                </cite>
              </div>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  )
}
